import React from 'react';

interface ConsecutiveWorkWarningProps {
  consecutiveDays: number;
}

const ConsecutiveWorkWarning: React.FC<ConsecutiveWorkWarningProps> = ({ consecutiveDays }) => {
  const isAtRisk = consecutiveDays >= 5; // 5일 연속이면 경고
  const isViolation = consecutiveDays >= 6; // 6일 연속이면 위반

  if (consecutiveDays === 0) {
    return null; // 근무일 없으면 표시 안 함
  }

  // 그라데이션 색상 (상태별)
  const gradientClass = isViolation 
    ? 'bg-gradient-to-r from-red-500 via-pink-500 to-orange-500' // 위반: 빨강~핑크~오렌지
    : isAtRisk 
    ? 'bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500' // 경고: 노랑~호박~오렌지
    : 'bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500'; // 안전: 초록~에메랄드~청록

  const percentage = Math.min(100, (consecutiveDays / 6) * 100);

  return (
    <div className={`rounded-2xl p-4 shadow-lg ${gradientClass}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className="text-2xl">
            {isViolation ? '🚨' : isAtRisk ? '⚠️' : '✅'}
          </span>
          <span className="text-white text-sm font-bold">연속 근무 경과</span>
        </div>
        <div className="bg-white bg-opacity-30 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full">
          {isViolation ? '위반' : isAtRisk ? '경고' : '안전'}
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <div>
          <p className="text-4xl font-black text-white mb-1">
            {consecutiveDays}일
          </p>
          <p className="text-xs text-white text-opacity-80">
            {isViolation 
              ? '주휴일 보장 필수!' 
              : isAtRisk 
              ? '1일 더 근무 시 위반' 
              : '근로기준법 준수 중'}
          </p>
        </div>

        {/* 프로그레스 바 */}
        <div className="flex flex-col items-end gap-1">
          <div className="w-24 bg-white bg-opacity-30 rounded-full h-3">
            <div 
              className="bg-white h-3 rounded-full transition-all shadow-lg"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <span className="text-xs text-white text-opacity-70">최대 6일</span>
        </div>
      </div>
    </div>
  );
};

export default ConsecutiveWorkWarning;
